import { useState } from 'react';
import { defineMessages } from '@alltrails/shared/react-intl';
import { Context } from '@alltrails/shared/types/context';
import Link from '@alltrails/shared/denali/components/Link';
import TrailsList from 'components/shared/TrailsList';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { Trail, TrailId } from 'types/Trails';
import { ServerCommunicationUtil } from 'utils/server_communication_util';
import { logTrailDetailsNearbyTrailClicked } from 'utils/trail_analytics_helpers';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import ListMethods from 'types/ListMethods';
import * as styles from './styles.module.scss';

const NEARBY_TRAILS_MESSAGES = defineMessages({ NEARBY_TRAILS: { defaultMessage: 'Nearby trails' }, SHOW_MORE: { defaultMessage: 'Show more' } });

export type NearbyTrailsListProps = {
  context: Context;
  explorePath?: string;
  listMethods: ListMethods;
  locationServerData: any;
  nearbyTrails: Trail[];
  trailId: TrailId;
};

const NearbyTrailsList = ({ context, explorePath, listMethods, locationServerData, nearbyTrails, trailId }: NearbyTrailsListProps): JSX.Element => {
  const {
    formattedDefaultMessages: { NEARBY_TRAILS, SHOW_MORE }
  } = useFormatMessage(NEARBY_TRAILS_MESSAGES);
  const languageRegionCode = useLanguageRegionCode();

  const [trails, setTrails] = useState(nearbyTrails);

  const onTrailClick = (trail: Trail) => {
    logTrailDetailsNearbyTrailClicked(trailId, trail.trail_id);
  };

  const loadMoreNearbyTrails = (pageNum: number, perPage: number, onSuccess: (newTrails: Trail[]) => void) => {
    ServerCommunicationUtil.loadMoreContent(
      'nearby_trails',
      null,
      locationServerData.type,
      locationServerData.trailId,
      pageNum,
      perPage,
      false,
      null,
      (data: any) => {
        setTrails(trails.concat(data.trails));
        onSuccess(data.trails);
      },
      false,
      null,
      null,
      languageRegionCode
    );
  };

  return (
    <div className={styles.nearbyTrailsContainer}>
      <div className={styles.nearbyTrailsHeader}>
        <h3 className={styles.headerText}>{NEARBY_TRAILS}</h3>
        <Link href={explorePath} size="sm" testId="nearby-trails-list-link">
          {SHOW_MORE}
        </Link>
      </div>
      <TrailsList
        adjustMaxCount
        context={context}
        listMethods={listMethods}
        loadMoreTrails={loadMoreNearbyTrails}
        onTrailClick={onTrailClick}
        serverTotalItems={100}
        trails={trails}
      />
    </div>
  );
};

export default NearbyTrailsList;
